"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useOnClickOutside = (ref, handler) => {
  (0, _react.useEffect)(() => {
    const listener = event => {
      const el = ref?.current;
      if (!el || el.contains(event?.target || null)) {
        return;
      }
      handler && handler(event); // Call the handler only if the click is outside of the element passed.
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]); // Reload only if ref or handler changes
};
var _default = exports.default = useOnClickOutside;
module.exports = exports.default;
module.exports.default = exports.default;